import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'

interface Props {
    isOpen: boolean
    onClose: () => void
    currency: string
}

function OpenNoCardsTopupModal({ isOpen, currency, onClose }: Props) {
    return (
        <Modal
            type="dialog"
            withHeaderBorder={false}
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="no_cards_topup_modal"
            size="xs"
        >
            <Content onClose={onClose} currency={currency} />
        </Modal>
    )
}

export default OpenNoCardsTopupModal
